// src/components/Forms/PhoneInput.js
import React from "react";
import { FormGroup, Label, Input, InputGroup, InputGroupText, FormFeedback } from "reactstrap";


const PhoneInput = ({
                        label = "Telefon Numarası",
                        value,
                        onChange,
                        onBlur,
                        name = "phoneNumber",
                        // Çağıran taraflar bu propları zaten geçiyordu ama bileşen
                        // karşılamadığı için doğrulama hataları sessizce kayboluyordu.
                        invalid = false,
                        errorText,
                    }) => {
    const handleInputChange = (e) => {
        const { value } = e.target;
        // Sadece rakamları al
        const digitsOnly = value.replace(/\D/g, "").slice(0, 10); // 10 hane sınırı
        const finalValue = `+90${digitsOnly}`;

        onChange({
            target: { name, value: finalValue },
        });
    };

    // Input içinde sadece son 10 hane gösterilsin
    const displayedValue = value?.replace("+90", "") || "";

    return (
        <FormGroup>
            {label && <Label for={name}>{label}</Label>}
            <InputGroup>
                <InputGroupText>+90</InputGroupText>
                <Input
                    id={name}
                    name={name}
                    type="tel"
                    value={displayedValue}
                    onChange={handleInputChange}
                    onBlur={onBlur}
                    placeholder="5xxxxxxxxx"
                    maxLength={10}
                    pattern="[0-9]{10}"
                    invalid={!!invalid}
                />
                {/* InputGroup içinde FormFeedback'in görünmesi için d-block gerekir. */}
                {invalid && errorText && (
                    <FormFeedback className="d-block">{errorText}</FormFeedback>
                )}
            </InputGroup>
            <small className="text-muted">Sadece 10 haneli cep numarası giriniz</small>
        </FormGroup>
    );
};

export default PhoneInput;